import { render, staticRenderFns } from "./AppointmentView.vue?vue&type=template&id=8c79eb22"
import script from "./AppointmentView.vue?vue&type=script&lang=js"
export * from "./AppointmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports